import { fetchUtils } from 'react-admin'
import axios from 'axios'
import { stringify } from 'query-string'
import { getJWT } from '../helper/localStore/getJWT'

const httpClient = fetchUtils.fetchJson

export default {
  getList: async (resource, params) => {
    const { page, perPage } = params.pagination
    const { field, order } = params.sort
    const query = {
      limit: JSON.stringify(perPage),
      skip: (page - 1) * perPage,
    }
    const formatOrder = (order) => {
      if (order === 'DESC') return '-'
      if (order === 'ASC') return '+'
      return '+'
    }

    // hasta que se normalice la libreria que se usa para filtrar
    // agregamos esta diferencia dependiendo el resource
    if (resource === 'business-rule' || resource === 'ext-air-airline') {
      query['order_by'] = `${formatOrder(order)}${field}`
    } else {
      query['ordering'] = `${field}.${order}`
    }

    const filters = (params) => {
      const array = []
      Object.entries(params.filter).forEach((value, i) => {
        let [key, val] = value

        // is_active(boolean) parameters accept only numbers
        if (val === true) {
          val = 1
        } else if (val === false) {
          val = 0
        }

        array.push(`&${key}=${val}`)
      })
      const filterstostring = array.join('')
      return filterstostring
    }

    const url = `${process.env.REACT_APP_URL_BUSINESS_RULE}/${resource}${resource === 'ext-air-airline' ? '/filter' : '/'}?${stringify(query)}${filters(
      params
    )}`
    try {
      const response = await axios.get(url, {
        headers: { 'authentication-token': getJWT() },
      })
      return {
        data: response.data,
        total: response.headers['row-counter'],
      }
    } catch (error) {
      localStorage.removeItem(`RaStore.${resource}.listParams`)
      throw new Error('url not found')
    }
  },
  getOne: (resource, params) =>
    resource === 'ext-air-airline' ? 
    httpClient(`${process.env.REACT_APP_URL_BUSINESS_RULE}/${resource}/${params.id}?ExtAirAirline_id=${params.id}`, {
      headers: new Headers({ 'authentication-token': getJWT() }),
    }).then(({ json }) => ({
      data: json,
    })):
    httpClient(`${process.env.REACT_APP_URL_BUSINESS_RULE}/${resource}/${params.id}`, {
      headers: new Headers({ 'authentication-token': getJWT() }),
    }).then(({ json }) => ({
      data: json,
    })),

  update: (resource, params) =>
    resource === 'ext-air-airline' ? 
    httpClient(`${process.env.REACT_APP_URL_BUSINESS_RULE}/${resource}/${params.id}?ExtAirAirline_id=${params.id}`, {
      method: 'PUT',
      body: JSON.stringify(params.data),
      headers: new Headers({ 'authentication-token': getJWT() }),
    }).then(({ json }) => ({ data: json })):
    httpClient(`${process.env.REACT_APP_URL_BUSINESS_RULE}/${resource}/${params.id}`, {
      method: 'PUT',
      body: JSON.stringify(params.data),
      headers: new Headers({ 'authentication-token': getJWT() }),
    }).then(({ json }) => ({ data: json })),

  create: (resource, params) =>
    httpClient(`${process.env.REACT_APP_URL_BUSINESS_RULE}/${resource}/`, {
      method: 'POST',
      body: JSON.stringify(params.data),
      headers: new Headers({ 'authentication-token': getJWT() }),
    }).then(({ json }) => ({
      data: { ...params.data, id: json.id },
    })),

  getMany: (resource, params) => {
    return httpClient(
      `${process.env.REACT_APP_URL_RESERVATION}/${resource}/?operator=or&id=${Object.values(
        params.ids
      ).toString()}`,
      {
        headers: new Headers({ 'authentication-token': getJWT() }),
      }
    ).then(({ json }) => {
      return { data: json }
    })
  },

  delete: (resource, params) =>
    resource === 'ext-air-airline' ? 
    httpClient(`${process.env.REACT_APP_URL_BUSINESS_RULE}/${resource}/${params.id}?ExtAirAirline_id=${params.id}`, {
      method: 'DELETE',
      headers: new Headers({ 'authentication-token': getJWT() }),
    }).then(({ json }) => ({ data: json })):
    httpClient(`${process.env.REACT_APP_URL_BUSINESS_RULE}/${resource}/${params.id}`, {
      method: 'DELETE',
      headers: new Headers({ 'authentication-token': getJWT() }),
    }).then(({ json }) => ({ data: json })),
}
